import { infoColor, infoBoxShadow, successColor, dangerColor } from '../global';

const detailCompanyStyle = () => ({
    items: {
        margin: '15px',
        display: 'flex',
        alignContent: 'baseline',
        '& p': {
            margin: '8px 0 8px 0',
        },
    },
    itemPayment: {
        margin: '15px 15px 0px 15px',
        display: 'flex',
        alignContent: 'baseline',
        '& p': {
            margin: '8px 0 8px 0',
        },
    },
    image: {
        marginTop: '8px',
        maxWidth: '300px',
        maxHeight: '200px',
    },
    groupButton: {
        marginTop: '-10px',
    },
    btn: {
        width: '100%',
        display: 'flex',
    },
    btnSave: {
        width: '88%',
        display: 'flex',
        justifyContent: 'center',
    },
    btnCancel: {
        width: '12%',
        display: 'flex',
        justifyContent: 'right',
    },
    booth: {
        borderRadius: '8px',
        ...infoBoxShadow,
        borderColor: infoColor,
        paddingLeft: '20px',
        paddingRight: '20px',
        width: '100%',
        height: '100%',
    },
    padding10: {
        padding: '10px',
    },
    maxHeight: {
        width: '650px',
        '& td,th': {
            padding: '0px 16px',
        },
    },
    tableEdit: {
        width: '500px',
        '& td,th': {
            padding: '0px 16px',
        },
    },
    time_ranger: {
        '& div': {
            '& div': {
                '& div': {
                    '& input': {
                        padding: '10px 0px 10px 12px',
                    },
                    '& div': {
                        marginLeft: '-18px',
                        '& button': {
                            padding: '7px',
                        },
                    },
                },
            },
        },
    },
    roomAddButton: {
        marginLeft: '-8px',
        color: successColor,
    },
    roomRemoveButton: {
        right: '20px',
        color: dangerColor,
        zIndex: 1,
    },
    name: {
        '& input': {
            padding: '6px',
            width: '333px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    numberInput: {
        width: '70px',
    },
    price: {
        '&:after': {
            content: '"円"',
            transform: 'translateX(calc(100% + 10px))',
        },
    },
    errorText: {
        margin: 0,
        fontSize: '0.75rem',
        textAlign: 'left',
        marginLeft: '28px',
    },
    checkBox: {
        '& span': {
            fontSize: '14px',
        },
    },
    checkBoxDisable: {
        pointerEvents: 'none',
        '& span': {
            fontSize: '14px',
        },
    },
});

export default detailCompanyStyle;
